import colors from 'styles/colors';

const MEMBER_COLORS = [
  colors.$info,
  colors.$warning,
  colors.$success,
  colors.$orange,
  colors.$purple,
  colors.$primary_medium,
  colors.$green_orchid,
  '#B3DD88',
  '#8899DD',
  '#DD8F88',
];

export const memberColor = (memberId: number, teamIds: number[]) => {
  const index = [...teamIds].sort((a, b) => a - b).indexOf(memberId);
  if (index === -1) return undefined;

  return MEMBER_COLORS[index % MEMBER_COLORS.length];
};
